import React from 'react';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model;

    return (
        <React.Fragment>
            <div className="calculator-controllers salary">
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CALCULATOR_CREDIT_SUM')}
                    </div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-slider-value">
                            {model.getCreditSum()} {calc.l10n('CALCULATOR_UAH')}
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                name="creditSum"
                                className="calculator-sum-slide"
                                onChange={calc.handleChange}
                                value={model.getCreditSum()}
                                min={model.getMinSumEdge()}
                                max={model.getMaxSumEdge()}
                                step={model.getSumStep()}
                            />
                        </div>
                    </div>
                </div>
                <p className="salary-notice">{calc.l10n('CALCULATOR_SALARY_PS')}</p>
            </div>
        </React.Fragment>);
}
